import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'
import { FaTimesCircle } from 'react-icons/fa'

type Props = ComponentPropsWithoutRef<typeof FaTimesCircle>

/**
 * 削除などを示すアイコン
 */
export const RemoveIcon: FC<Props> = ({ className, ...props }) => {
  return (
    <FaTimesCircle {...props} className={clsx(['text-gray-1', className])} />
  )
}
